<template>
  <div class="page main-background">
    <div class="sub-header">
      <h2>استعلام وضعیت پلاک ها</h2>
    </div>
    <div class="custom-box mar40t">
      <div class="custom-box-text" style="padding-top: 30px;">
        برای استعلام پلاک‌های فعال، تنها کافی است کد ملی و تلفن همراه خود را
        وارد کرده و وضعیت کلیه پلاک‌های نصب شده و فک شده خود را مشاهده کنید.
        تنها با پرداخت 5200 تومان به عنوان هزینه استعلام می‌توانید از این سرویس
        استفاده کنید.
      </div>
      <div>
        <span class="icon-box">
          <i class="far fa-car"></i>
        </span>
      </div>
      <div>
        <input
          type="text"
          class="input"
          v-model="NationalityCodeInput"
          placeholder="کد ملی دارنده گواهینامه"
          maxlength="10"
          @keypress="isNumber($event)"
        />
        <input
          type="text"
          class="input"
          v-model="MobileInput"
          placeholder="تلفن همراه دارنده گواهینامه"
          maxlength="11"
          @keypress="isNumber($event)"
        />
        <input
          v-if="this.CodeFlag"
          type="text"
          class="input"
          v-model="Code"
          placeholder="کد ارسال شده به تلفن همراه"
          maxlength="5"
          @keypress="isNumber($event)"
        />
        <span
          v-if="this.NationalityCodeActive == true && this.MobileActive == true"
        >
          <span v-if="this.userMobile == this.MobileInput">
            <a class="input primary-btn" @click="getInquiry">استعلام</a>
          </span>
          <span v-else-if="this.userMobile != this.MobileInput && !this.Code">
            <a class="input primary-btn" @click="sendOtp">استعلام</a>
          </span>
          <span v-else-if="this.userMobile != this.MobileInput && this.Code">
            <a class="input primary-btn" @click="getInquiry">استعلام</a>
          </span>
        </span>
        <span v-else>
          <div class="input primary-btn deactive">استعلام</div>
        </span>
      </div>
    </div>
    <div v-if="!loading">
      <div v-if="errorMessage">
        <div
          class="error-message"
          v-if="errorMessage"
          style="text-align: center; margin: 0 10px 0"
        >
          <h3 class="loading-title text-color">
            {{ errorMessage }}
          </h3>
        </div>
      </div>
      <div v-if="!errorMessage && this.activePlak" style="margin: 0 0 10px 0">
        <h2 class="page-title text-color">نتیجه استعلام وضعیت پلاک ها</h2>
        <div v-for="item in this.activePlak.plaques" :key="item.id">
          <div class="fines text-color border-color background-color fines">
            <table>
              <tr>
                <th class="fines-header">شماره پلاک</th>
                <th class="fines-header">شماره سریال</th>
                <th class="fines-header">فک پلاک</th>
                <th class="fines-header">توضیحات</th>
              </tr>
              <tr>
                <td>{{ item.plaque }}</td>
                <td>{{ item.secInSerial }}</td>
                <td v-if="item.is_Fak == 1">
                  پلاک در تاریخ {{ item.mnfk_SHDN_DATE }} فک شده است.
                </td>
                <td v-else>
                  -
                </td>
                <td>
                  <span v-if="item.description">
                    {{ item.description }}
                  </span>
                  <span
                    v-else-if="
                      !item.description && item.is_Fak && item.is_Fak != 1
                    "
                  >
                    پلاک فعال است
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-if="!errorMessage && this.activePlak == ''">
        <div
          class="success-message"
          style="text-align: center; margin: 10px 10px 0"
        >
          شما پلاک فعالی ندارید
        </div>
      </div>
    </div>
    <div v-if="loading">
      <h3 class="loading-title text-color loading-box">
        در حال دریافت استعلام وضعیت پلاک ها، لطفا شکیبا باشید.
      </h3>
      <loader />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api, { BaseUrl_New } from "../../service";
import loader from "../../components/inquiry/Loader";

export default {
  name: "active-plak-inquiry",
  components: {
    loader,
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      activePlak: null,
      NationalityCodeInput: "",
      MobileInput: "",
      Code: "",
      baseUrl: BaseUrl_New,
      client: 3,
      NationalityCodeActive: false,
      MobileActive: false,
      CodeFlag: false,
      userMobile: "",
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  mounted() {
    this.loading = true;
    // this.activePlak = {
    //   plaques: [
    //     {
    //       plaqueNumber: "331259767",
    //       plaque: "ایران ۳۳ - ۷۶۷ م  ۵۹",
    //       secInSerial: "1010123603963",
    //       socialNo: "4650435366",
    //       is_Fak: "0",
    //     },
    //     {
    //       plaqueNumber: "810241793",
    //       plaque: "ایران ۸۱ - ۷۹۳ ب  ۴۱",
    //       secInSerial: "10100413325749",
    //       socialNo: "4650435366",
    //       mnfk_SHDN_DATE: "1388/08/04",
    //       is_Fak: "1",
    //       description: "شماره گذاري بروجن",
    //     },
    //     {
    //       plaqueNumber: "880869157",
    //       plaque: "ایران ۸۸ - ۱۵۷ ط  ۶۹",
    //       secInSerial: "10101441204343",
    //       socialNo: "4650435366",
    //       is_Fak: "0",
    //     },
    //     {
    //       plaqueNumber: "880869157",
    //       plaque: "ایران ۸۸ - ۱۵۷ ط  ۶۹",
    //       secInSerial: "1010233263988",
    //       socialNo: "4650435366",
    //       mnfk_SHDN_DATE: "1398/01/18",
    //       is_Fak: "1",
    //       description: "شماره گذاري شهرکرد",
    //     },
    //     {
    //       plaqueNumber: "101518327",
    //       plaque: "ایران ۱۰ - ۳۲۷ ﻫ  ۱۸",
    //       secInSerial: "10100436653307",
    //       socialNo: "4650435366",
    //       mnfk_SHDN_DATE: "1398/01/11",
    //       is_Fak: "1",
    //       description: "شماره گذاري شهرکرد",
    //     },
    //   ],
    // };

    // this.activePlak = {
    //   plaques: [
    //     {
    //       plaqueNumber: "221453248",
    //       plaque: "ایران ۲۲ - ۲۴۸ و  ۵۳",
    //       secInSerial: "10100225952705",
    //       socialNo: "0052230996",
    //       is_Fak: "0",
    //     },
    //     {
    //       plaqueNumber: "771293892",
    //       plaque: "ایران ۷۷ - ۸۹۲ م  ۹۳",
    //       secInSerial: "1010216326807",
    //       socialNo: "0052230996",
    //       is_Fak: "0",
    //     },
    //   ],
    // };

    // this.activePlak = {
    //   plaks: [
    //     {
    //       plakNumber: "331259767",
    //       plak: "ایران ۳۳ - ۷۶۷ م  ۵۹",
    //       secInSerial: "1010123603963",
    //       socialNo: "4650435366",
    //       is_Fak: "0",
    //     },
    //     {
    //       plakNumber: "810241793",
    //       plak: "ایران ۸۱ - ۷۹۳ ب  ۴۱",
    //       secInSerial: "10100413325749",
    //       socialNo: "4650435366",
    //       mnfk_SHDN_DATE: "2009-10-26 07:24:50",
    //       is_Fak: "1",
    //       description: "شماره گذاري بروجن",
    //     },
    //     {
    //       plakNumber: "880869157",
    //       plak: "ایران ۸۸ - ۱۵۷ ط  ۶۹",
    //       secInSerial: "10101441204343",
    //       socialNo: "4650435366",
    //       is_Fak: "0",
    //     },
    //     {
    //       plakNumber: "880869157",
    //       plak: "ایران ۸۸ - ۱۵۷ ط  ۶۹",
    //       secInSerial: "1010233263988",
    //       socialNo: "4650435366",
    //       mnfk_SHDN_DATE: "2019-04-07 12:06:23",
    //       is_Fak: "1",
    //       description: "شماره گذاري شهرکرد",
    //     },
    //     {
    //       plakNumber: "101518327",
    //       plak: "ایران ۱۰ - ۳۲۷ ﻫ  ۱۸",
    //       secInSerial: "10100436653307",
    //       socialNo: "4650435366",
    //       mnfk_SHDN_DATE: "2019-03-31 11:18:10",
    //       is_Fak: "1",
    //       description: "شماره گذاري شهرکرد",
    //     },
    //   ],
    // };
    api
      .getUserInformation()
      .then((response) => {
        if (response.data && response.data.status === 200) {
          this.userMobile = response.data.data.mobile;
          //console.log(response.data.data);
        } else {
          if (
            response.data &&
            response.data.Messages &&
            response.data.Messages.length > 0
          ) {
            this.errorMessage = response.data.Messages[0];
          }
        }
      })
      .catch(() => {
        this.errorMessage =
          "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    isNumber: function(e) {
      var iKeyCode = e.which ? e.which : e.keyCode;
      if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
        e.preventDefault();
      return true;
    },
    sendOtp() {
      this.CodeFlag = true;
      api
        .getSendOtp(this.MobileInput)
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.errorMessage = response.data.messages[0];
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch((err) => {
          this.errorMessage =
            "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
          this.errorMessage = err.response.data.messages[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getInquiry() {
      this.errorMessage = "";
      api
        .getActivePlakInquiryByInfo(
          this.client,
          this.Code,
          this.MobileInput,
          this.NationalityCodeInput
        )
        .then((response) => {
          if (
            response.data &&
            response.data.status === 200 &&
            response.data.status === 200
          ) {
            this.activePlak = response.data.data;
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch((err) => {
          this.errorMessage =
            "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
          this.errorMessage = err.response.data.messages[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    MobileInput(item) {
      if (item) {
        this.MobileActive = true;
      } else {
        this.MobileActive = false;
      }
    },
    NationalityCodeInput(item) {
      if (item) {
        this.NationalityCodeActive = true;
      } else {
        this.NationalityCodeActive = false;
      }
    },
  },
};
</script>

<style scoped></style>
